export const convertTenorList = (tenors, selectedPawnType, isExtension) => {
  let convertedTenors = [];

  if (tenors.length !== 0) {
    if (selectedPawnType) {
      tenors.forEach((tenor) => {
        if (isExtension || tenor.gadai_type === selectedPawnType) {
          convertedTenors.push({
            value: tenor.days,
            label: `${tenor.days} Hari`,
          });
        }
      });
    }
  }
  
  const unique = [...new Map(convertedTenors.map((m) => [m.value, m])).values()]; //get uniq value
  return unique;
};
